import { Action } from "@ngrx/store";

export enum EAdminActions {
  FetchAuctionsListAttempt = "[Admin] Fetch Auctions List Attempt",
  FetchAuctionsListSuccess = "[Admin] Fetch Auctions List Success",
  FetchAuctionsListFailed = "[Admin] Fetch Auctions List Failed",

  FetchAuctionAttempt = "[Admin] Fetch Auction Attempt",
  FetchAuctionSuccess = "[Admin] Fetch Auction Success",
  FetchAuctionFailed = "[Admin] Fetch Auction Failed",

  UpdateAuctionAttempt = "[Admin] Update Auction Attempt",
  UpdateAuctionSuccess = "[Admin] Update Auction Success",
  UpdateAuctionFailed = "[Admin] Update Auction Failed",

  FetchBalanceWithdrawListAttempt = "[Admin] Fetch Balance Withdraw List Attempt",
  FetchBalanceWithdrawListSuccess = "[Admin] Fetch Balance Withdraw List Success",
  FetchBalanceWithdrawListFailed = "[Admin] Fetch Balance Withdraw List Failed",

  BalanceWithdrawStatusChangeAttempt = "[Admin] Balance Withdraw Status Change Attempt",
  BalanceWithdrawStatusChangeSuccess = "[Admin] Balance Withdraw Status Change Success",
  BalanceWithdrawStatusChangeFailed = "[Admin] Balance Withdraw Status Change Failed",

  FetchUserDataAttempt = "[Admin] Fetch User Data Attempt",
  FetchUserDataSuccess = "[Admin] Fetch User Data Success",
  FetchUserDataFailed = "[Admin] Fetch User Data Failed",

  FetchUnprocessedTransactionsListAttempt = "[Admin] Fetch Unprocessed Transactions List Attempt",
  FetchUnprocessedTransactionsListSuccess = "[Admin] Fetch Unprocessed Transactions List Success",
  FetchUnprocessedTransactionsListFailed = "[Admin] Fetch Unprocessed Transactions List Failed",

  FetchTransactionsListAttempt = "[Admin] Fetch Transactions List Attempt",
  FetchTransactionsListSuccess = "[Admin] Fetch Transactions List Success",
  FetchTransactionsListFailed = "[Admin] Fetch Transactions List Failed",

  RefundPaymentAttempt = "[Admin] Refund Payment Attempt",
  RefundPaymentSuccess = "[Admin] Refund Payment Success",
  RefundPaymentFailed = "[Admin] Refund Payment Failed",

  RefundedPaymentAttempt = "[Admin] Refuned Payment Attempt",
  RefundedPaymentSuccess = "[Admin] Refunded Payment Success",
  RefundedPaymentFailed = "[Admin] Refunded Payment Failed",
}

export class FetchAuctionsListAttempt implements Action {
  public readonly type = EAdminActions.FetchAuctionsListAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchAuctionsListSuccess implements Action {
  public readonly type = EAdminActions.FetchAuctionsListSuccess;
  constructor(public payload: any) {}
}

export class FetchAuctionsListFailed implements Action {
  public readonly type = EAdminActions.FetchAuctionsListFailed;
  constructor(public payload: Array<string>) {}
}

export class FetchAuctionAttempt implements Action {
  public readonly type = EAdminActions.FetchAuctionAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchAuctionSuccess implements Action {
  public readonly type = EAdminActions.FetchAuctionSuccess;
  constructor(public payload: any) {}
}

export class FetchAuctionFailed implements Action {
  public readonly type = EAdminActions.FetchAuctionFailed;
  constructor(public payload: Array<string>) {}
}

export class FetchBalanceWithdrawListAttempt implements Action {
  public readonly type = EAdminActions.FetchBalanceWithdrawListAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchBalanceWithdrawListSuccess implements Action {
  public readonly type = EAdminActions.FetchBalanceWithdrawListSuccess;
  constructor(public payload: any) {}
}

export class FetchBalanceWithdrawListFailed implements Action {
  public readonly type = EAdminActions.FetchBalanceWithdrawListFailed;
  constructor(public payload: Array<string>) {}
}

export class BalanceWithdrawStatusChangeAttempt implements Action {
  public readonly type = EAdminActions.BalanceWithdrawStatusChangeAttempt;
  constructor(
    public payload: any = {},
    public balanceWithdrawItemId: number | string,
  ) {}
}

export class BalanceWithdrawStatusChangeSuccess implements Action {
  public readonly type = EAdminActions.BalanceWithdrawStatusChangeSuccess;
  constructor(public payload: any) {}
}

export class BalanceWithdrawStatusChangeFailed implements Action {
  public readonly type = EAdminActions.BalanceWithdrawStatusChangeFailed;
  constructor(public payload: Array<string>) {}
}

export class UpdateAuctionAttempt implements Action {
  public readonly type = EAdminActions.UpdateAuctionAttempt;
  constructor(
    public payload: any = {},
    public auctionId: number | string,
  ) {}
}

export class UpdateAuctionSuccess implements Action {
  public readonly type = EAdminActions.UpdateAuctionSuccess;
  constructor(public payload: any) {}
}

export class UpdateAuctionFailed implements Action {
  public readonly type = EAdminActions.UpdateAuctionFailed;
  constructor(public payload: Array<string>) {}
}

export class FetchUserDataAttempt implements Action {
  public readonly type = EAdminActions.FetchUserDataAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchUserDataSuccess implements Action {
  public readonly type = EAdminActions.FetchUserDataSuccess;
  constructor(public payload: any) {}
}

export class FetchUserDataFailed implements Action {
  public readonly type = EAdminActions.FetchUserDataFailed;
  constructor(public payload: Array<string>) {}
}
export class FetchUnprocessedTransactionsListAttempt implements Action {
  public readonly type = EAdminActions.FetchUnprocessedTransactionsListAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchUnprocessedTransactionsListSuccess implements Action {
  public readonly type = EAdminActions.FetchUnprocessedTransactionsListSuccess;
  constructor(public payload: any) {}
}

export class FetchUnprocessedTransactionsListFailed implements Action {
  public readonly type = EAdminActions.FetchUnprocessedTransactionsListFailed;
  constructor(public payload: Array<string>) {}
}

export class FetchTransactionsListAttempt implements Action {
  public readonly type = EAdminActions.FetchTransactionsListAttempt;
  constructor(public payload: any = {}) {}
}

export class FetchTransactionsListSuccess implements Action {
  public readonly type = EAdminActions.FetchTransactionsListSuccess;
  constructor(public payload: any) {}
}

export class FetchTransactionsListFailed implements Action {
  public readonly type = EAdminActions.FetchTransactionsListFailed;
  constructor(public payload: Array<string>) {}
}

export class RefundPaymentAttempt implements Action {
  public readonly type = EAdminActions.RefundPaymentAttempt;
  constructor(
    public payload: any = {},
    public refreshData: Function,
  ) {}
}

export class RefundPaymentSuccess implements Action {
  public readonly type = EAdminActions.RefundPaymentSuccess;
  constructor(public payload: any) {}
}

export class RefundPaymentFailed implements Action {
  public readonly type = EAdminActions.RefundPaymentFailed;
  constructor(public payload: Array<string>) {}
}

export class RefundedPaymentAttempt implements Action {
  public readonly type = EAdminActions.RefundedPaymentAttempt;
  constructor(
    public payload: any = {},
    public openRefundedModalState: Function,
  ) {}
}

export class RefundedPaymentSuccess implements Action {
  public readonly type = EAdminActions.RefundedPaymentSuccess;
  constructor(public payload: any) {}
}

export class RefundedPaymentFailed implements Action {
  public readonly type = EAdminActions.RefundedPaymentFailed;
  constructor(public payload: Array<string>) {}
}

export type AdminActions =
  | FetchAuctionsListAttempt
  | FetchAuctionsListSuccess
  | FetchAuctionsListFailed
  | FetchAuctionAttempt
  | FetchAuctionSuccess
  | FetchAuctionFailed
  | FetchBalanceWithdrawListAttempt
  | FetchBalanceWithdrawListSuccess
  | FetchBalanceWithdrawListFailed
  | BalanceWithdrawStatusChangeAttempt
  | BalanceWithdrawStatusChangeSuccess
  | BalanceWithdrawStatusChangeFailed
  | UpdateAuctionAttempt
  | UpdateAuctionSuccess
  | UpdateAuctionFailed
  | FetchUserDataAttempt
  | FetchUserDataSuccess
  | FetchUserDataFailed
  | FetchUnprocessedTransactionsListAttempt
  | FetchUnprocessedTransactionsListSuccess
  | FetchUnprocessedTransactionsListFailed
  | FetchTransactionsListAttempt
  | FetchTransactionsListSuccess
  | FetchTransactionsListFailed
  | RefundPaymentAttempt
  | RefundPaymentSuccess
  | RefundPaymentFailed
  | RefundedPaymentAttempt
  | RefundedPaymentSuccess
  | RefundedPaymentFailed;
